module.exports = __webpack_public_path__ + "static/media/ally_pro_web_7.7a476147.jpg";